import SHGooglePlacesSearch from 'sh-google-places-search';

SHGooglePlacesSearch.init({
    size: 'lg'
});



// WEBPACK FOOTER //
// ./spothero/static/searchbar/src/js/searchbar.js